//selectors are to be maintained/updated as store grows.

export const selectCommonLoading = (state) => state.common.Loading;
export const selectCommonError = (state) => state.common.Errors;

export const selectConfiguration = (state) => state.config.configuration;

/**User selectors */

export const selectAuthenticated = (state) => state.user.isAuthenticated;
export const selectUserVerified = (state) => state.user.isVerified;

export const selectSubscriberId = (state) => state.user.subscriberId;
export const selectSubscriberEmail = (state) => state.user.email;
export const selectSubscriberName = (state) => state.user.data?.subscribername;
export const selectSubscriberData = (state) => state.user.data;


export const selectLanguage = ( state ) => state.user.language || 'eng' ;
export const selectLanguageList = ( state ) => state.user.languageList ?? [];
export const selectLanguageMeta = ( state ) => state.user.langmeta ?? {} ;
/**User selectors */

/** Profile  Selectors */

export const selectProfiles = (state) => state.profile.profiles;
export const selectCurrentProfile = (state) => {
  const profileid = state.profile.selected;
  const profiles = state.profile.profiles;
  return profiles.length === 1
    ? profiles[0]
    : profiles.find((profile) => profile.profileid === profileid) ?? null;
};

export const selectOtherProfile = (state) => {
    const profileid = state.profile.selected;
    const profiles = state.profile.profiles;
    return profiles.length === 1
      ? profiles[0]
      : profiles.find((profile) => profile.profileid != profileid) ?? null;
  };

export const selectTimerData = (state) => {
  const currentprofile = selectCurrentProfile(state);
  return currentprofile?.timerData;
};

export const selectCurrentLevel = (state) => state.profile.currentLevel;

export const selectdisabledlevels = (state) => state.profile.disabledLevels

export const selectGamestatus = (state) => state.user.isgamePlaying;

export const selectSocialloginstatus = (state) => state.user.SocialLogin;

/** Profile  Selectors */

/** Avatars Selectors */

export const selectAvatars = ( state ) => state.avatars.list.map( avatar => {

  const mode = state.rewards.avatars?.some( reward => reward.avatarid === avatar.castncrewid ) ? 'UNLOCKED' : avatar.mode ;

  return { ...avatar, mode } ;
}) ;

export const selectCurrentAvatar = ( state ) => state.avatars.list.find( avatar => (
  avatar.castncrewid === state.avatars.current
))?? {};
/** Avatars Selectors */

/** Course Selectors */
export const selectCourses = (state) => state.course.courseList;
export const selectCoursePage = (state) => state.course.page;
/** Course Selectors */

/** Stories Selectors */
export const selectStories = (state) => state.stories.storyList;
export const selectStoriesPage = (state) => state.stories.page;
/** Stories Selectors */

/** Plans Selectors */
export const selectPlans = (state) => state.plans.plans;

export const selectUserPlan = (state) => state.plans.userPlan;
/** Plans Selectors */

/** Rewards Selectors */
export const selectRewards = ( state ) => state.rewards ;
/**  Rewards Selectors */

/** analytics selectors */

export const selectCommonAnalytics = (state)=> {
    const commonanalyticsdata = {};
    commonanalyticsdata.UserMode = "REGISTERED"
    commonanalyticsdata.Email = selectSubscriberEmail(state) ? selectSubscriberEmail(state) : null;
    commonanalyticsdata.SubscriberID = selectSubscriberId(state) ? selectSubscriberId(state) : null;
    commonanalyticsdata.Level = selectCurrentProfile(state) ? selectCurrentProfile(state)?.currentLevel : null;
    commonanalyticsdata.ProfileID = selectCurrentProfile(state) ? selectCurrentProfile(state)?.profileid : null;
    return commonanalyticsdata
}
